import { Loader2 } from "lucide-react";

export const Loader = ({ className }: { className?: string }) => (
    <Loader2 className={`h-4 w-4 animate-spin ${className ?? ""}`} />
);
